import classnames from 'clsx';

import style from './collapsible-list-section-content.module.css';

import type { CollapsibleListSectionCollapsedContentComponent } from './collapsible-list-section-content-types';

export const CollapsibleListSectionCollapsedContent: CollapsibleListSectionCollapsedContentComponent = ({ children, className = null }) => {
  return <div className={classnames(style['collapsible-list-section-content'], className)}>{children}</div>;
};
